import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

function onChange(value, dateString) {}

function onOk(value) {}

class DateTimePicker extends React.Component {
  render() {
    return (
      <div>
        <DatePicker
          showTime
          format="YYYY-MM-DD HH:mm:ss"
          placeholder="Select Time"
          onChange={this.props.onChange}
          onOk={onOk}
          defaultValue={this.props.defaultValue || moment()}
          disabled={this.props.disabled || false}
          allowClear={false}
        />
      </div>
    );
  }
}
export default DateTimePicker;



// WEBPACK FOOTER //
// ./src/components/DateTimePicker.js